import { pxToRem } from "./utils";

const oneUnitOfSpacing = 8;

export const makeSpacing = (multiplier: number) =>
  pxToRem(multiplier * oneUnitOfSpacing);

export type RowanTheme = {
  colours: {
    primary: {
      light: {
        _5: string;
        _10: string;
        _15: string;
        _20: string;
        _30: string;
        _40: string;
        _50: string;
        _60: string;
        _70: string;
      };
      mid: {
        light10: string;
        light20: string;
        mid: string;
        dark10: string;
        dark20: string;
      };
      dark: {
        _10: string;
        _20: string;
        _30: string;
        _40: string;
        _50: string;
        _60: string;
      };
    };
    accent: {
      light: {
        _5: string;
        _10: string;
        _15: string;
        _20: string;
        _30: string;
        _40: string;
        _50: string;
        _60: string;
        _70: string;
      };
      mid: {
        light10: string;
        light20: string;
        mid: string;
        dark10: string;
        dark15: string;
        dark20: string;
      };
      dark: {
        _10: string;
        _20: string;
        _30: string;
        _40: string;
        _50: string;
        _60: string;
      };
    };
    success: {
      light: {
        _5: string;
        _10: string;
        _15: string;
        _20: string;
        _30: string;
        _40: string;
        _50: string;
        _60: string;
        _70: string;
      };
      mid: {
        light10: string;
        light20: string;
        mid: string;
        dark10: string;
        dark20: string;
      };
      dark: {
        _10: string;
        _20: string;
        _30: string;
        _40: string;
        _50: string;
        _60: string;
      };
    };
    error: {
      light: {
        _5: string;
        _10: string;
        _15: string;
        _20: string;
        _30: string;
        _40: string;
        _50: string;
        _60: string;
        _70: string;
      };
      mid: {
        light10: string;
        light20: string;
        mid: string;
        dark10: string;
        dark20: string;
      };
      dark: {
        _10: string;
        _20: string;
        _30: string;
        _40: string;
        _50: string;
        _60: string;
      };
    };
    uIGrey: {
      light: {
        _5: string;
        _10: string;
        _15: string;
        _20: string;
        _30: string;
        _40: string;
        _50: string;
        _60: string;
        _70: string;
        _0: string;
      };
      mid: {
        light_10: string;
        light_20: string;
        mid: string;
        dark_5: string;
        dark_10: string;
        dark_20: string;
      };
      dark: {
        _10: string;
        _20: string;
        _30: string;
        _40: string;
        _50: string;
        _60: string;
        _70: string;
      };
    };
    highlight: {
      yellow: string;
      darkYellow: string;
      apple: string;
      orange: string;
      peach: string;
      pink: string;
      purple: string;
      violet: string;
      blue: string;
      teal: string;
      green: string;
    };
    other: {
      greenBackground: string;
    };
    bolt: string;
  };
  customTypography: {
    jumbo: {
      _1: {
        fontFamily: string;
        fontSize: string;
        fontWeight: number;
        letterSpacing: string;
        lineHeight: number;
      };
      _2: {
        fontFamily: string;
        fontSize: string;
        fontWeight: number;
        letterSpacing: string;
        lineHeight: number;
      };
      _3: {
        fontFamily: string;
        fontSize: string;
        fontWeight: number;
        letterSpacing: string;
        lineHeight: number;
      };
      _4: {
        fontFamily: string;
        fontSize: string;
        fontWeight: number;
        letterSpacing: string;
        lineHeight: number;
      };
      _5: {
        fontFamily: string;
        fontSize: string;
        fontWeight: number;
        letterSpacing: string;
        lineHeight: number;
      };
    };
    title: {
      _1: {
        fontFamily: string;
        fontSize: string;
        fontWeight: number;
        letterSpacing: string;
        lineHeight: number;
      };
      _2: {
        fontFamily: string;
        fontSize: string;
        fontWeight: number;
        letterSpacing: string;
        lineHeight: number;
      };
      _3: {
        fontFamily: string;
        fontSize: string;
        fontWeight: number;
        letterSpacing: string;
        lineHeight: number;
      };
    };
    label: {
      _1: {
        fontFamily: string;
        fontSize: string;
        fontWeight: number;
        letterSpacing: string;
        lineHeight: number;
      };
      _2: {
        fontFamily: string;
        fontSize: string;
        fontWeight: number;
        letterSpacing: string;
        lineHeight: number;
      };
      _3: {
        fontFamily: string;
        fontSize: string;
        fontWeight: number;
        letterSpacing: string;
        lineHeight: number;
      };
      _4: {
        fontFamily: string;
        fontSize: string;
        fontWeight: number;
        letterSpacing: string;
        lineHeight: number;
      };
    };
    paragraph: {
      _1: {
        fontFamily: string;
        fontSize: string;
        fontWeight: number;
        letterSpacing: string;
        lineHeight: number;
      };
      _2: {
        fontFamily: string;
        fontSize: string;
        fontWeight: number;
        letterSpacing: string;
        lineHeight: number;
      };
      _3: {
        fontFamily: string;
        fontSize: string;
        fontWeight: number;
        letterSpacing: string;
        lineHeight: number;
      };
      _4: {
        fontFamily: string;
        fontSize: string;
        fontWeight: number;
        letterSpacing: string;
        lineHeight: number;
      };
    };
    overline: {
      _1: {
        fontFamily: string;
        fontSize: string;
        fontWeight: number;
        letterSpacing: string;
        lineHeight: number;
      };
      _2: {
        fontFamily: string;
        fontSize: string;
        fontWeight: number;
        letterSpacing: string;
        lineHeight: number;
      };
      _3: {
        fontFamily: string;
        fontSize: string;
        fontWeight: number;
        letterSpacing: string;
        lineHeight: number;
      };
      _4: {
        fontFamily: string;
        fontSize: string;
        fontWeight: number;
        letterSpacing: string;
        lineHeight: number;
      };
    };
    book: {
      title: {
        _1: {
          fontFamily: string;
          fontSize: string;
          fontWeight: number;
          letterSpacing: string;
          lineHeight: number;
        };
        _2: {
          fontFamily: string;
          fontSize: string;
          fontWeight: number;
          letterSpacing: string;
          lineHeight: number;
        };
        _3: {
          fontFamily: string;
          fontSize: string;
          fontWeight: number;
          letterSpacing: string;
          lineHeight: number;
        };
      };
      label: {
        _1: {
          fontFamily: string;
          fontSize: string;
          fontWeight: number;
          letterSpacing: string;
          lineHeight: number;
        };
        _2: {
          fontFamily: string;
          fontSize: string;
          fontWeight: number;
          letterSpacing: string;
          lineHeight: number;
        };
        _3: {
          fontFamily: string;
          fontSize: string;
          fontWeight: number;
          letterSpacing: string;
          lineHeight: number;
        };
        _4: {
          fontFamily: string;
          fontSize: string;
          fontWeight: number;
          letterSpacing: string;
          lineHeight: number;
        };
      };
      paragraph: {
        _1: {
          fontFamily: string;
          fontSize: string;
          fontWeight: number;
          letterSpacing: string;
          lineHeight: number;
        };
        _2: {
          fontFamily: string;
          fontSize: string;
          fontWeight: number;
          letterSpacing: string;
          lineHeight: number;
        };
        _3: {
          fontFamily: string;
          fontSize: string;
          fontWeight: number;
          letterSpacing: string;
          lineHeight: number;
        };
        _4: {
          fontFamily: string;
          fontSize: string;
          fontWeight: number;
          letterSpacing: string;
          lineHeight: number;
        };
      };
      overline: {
        _1: {
          fontFamily: string;
          fontSize: string;
          fontWeight: number;
          letterSpacing: string;
          lineHeight: number;
        };
        _2: {
          fontFamily: string;
          fontSize: string;
          fontWeight: number;
          letterSpacing: string;
          lineHeight: number;
        };
        _3: {
          fontFamily: string;
          fontSize: string;
          fontWeight: number;
          letterSpacing: string;
          lineHeight: number;
        };
        _4: {
          fontFamily: string;
          fontSize: string;
          fontWeight: number;
          letterSpacing: string;
          lineHeight: number;
        };
      };
    };
  };
  spacing: typeof makeSpacing;
  layers: {
    relief: {
      accent_5: {
        shadow: string;
      };
      accent_10: {
        shadowHigher: string;
      };
      accent_20: {
        noShadow: string;
        shadow: string;
      };
      accent_30: {
        noShadow: string;
        shadow: string;
      };
      accent_50: {
        noShadow: string;
      };
      accent_70: {
        shadow: string;
        noShadow: string;
      };
      accentDark_10: {
        noShadow: string;
      };
      primaryDark_10: {
        noShadow: string;
        shadow: string;
      };
      primaryMidDark_20: {
        shadowHigher: string;
      };
      uiGrey_5: {
        shadow: string;
        noShadow: string;
      };
      uiGrey_10: {
        shadowHigher: string;
        shadow: string;
      };
      uiGrey_30: {
        shadow: string;
      };
      uiGrey_40: {
        shadow: string;
        noShadow: string;
      };
    };
    inset: {
      primaryDark_10: {
        shadow: string;
        noShadow: string;
      };
    };
    bubble: {
      uiGrey_10: {
        shadow: string;
      };
    };
  };
  breakpoints: {
    values: {
      xs: number;
      sm: number;
      md: number;
      lg: number;
      xl: number;
    };
  };
  layout: {
    contentMaxWidth: string;
    gutter: string;
  };
};
